import Constants from "../../Constants";
import Api from "../../Api";
import {map} from "rxjs/operators";
import {DataTypeDefinitionCreateDto, DataTypeDefinitionDto, DataTypeDefinitionUpdateDto} from "./DataTypeDefinitionDto";
import {AjaxRequest} from "rxjs/internal/observable/dom/AjaxObservable";
import {DataTypeConstraintCreateDto} from "./DataTypeConstraintDto";

export enum DataTypeErrorCode {
    DATA_TYPE_IS_IN_USE = "dataType.DATA_TYPE_IS_IN_USE",
    CONSTRAINTS_CONFLICTING_NAME = "CONSTRAINTS_CONFLICTING_NAME",
}

export class DataTypeApiClient {

    public static readonly ENDPOINT_URL: string = Constants.API_HOST + "/rest-api/data-types";

    findAll(): Promise<DataTypeDefinitionDto[]> {
        const request = {
            url: DataTypeApiClient.ENDPOINT_URL,
            method: "GET",
        };
        return Api.createAjax(request)
            .pipe(
                map((response) => response.response as DataTypeDefinitionDto[])
            ).toPromise();
    }

    findById(dataTypeDefinitionId: string): Promise<DataTypeDefinitionDto> {
        const request: AjaxRequest = {
            url: `${DataTypeApiClient.ENDPOINT_URL}/${dataTypeDefinitionId}`,
            method: "GET",
        };
        return Api.createAjax(request)
            .pipe(
                map((response) => response.response as DataTypeDefinitionDto)
            ).toPromise();
    }

    create(dataTypeDefinition: DataTypeDefinitionCreateDto): Promise<string> {
        const request: AjaxRequest = {
            url: `${DataTypeApiClient.ENDPOINT_URL}`,
            method: "POST",
            body: dataTypeDefinition,
        };
        return Api.createAjax(request)
            .pipe(
                map((response) => response.response as string)
            ).toPromise();
    }

    update(dataTypeDefinitionId: string, dataTypeDefinitionUpdate: DataTypeDefinitionUpdateDto): Promise<void> {
        const request: AjaxRequest = {
            url: `${DataTypeApiClient.ENDPOINT_URL}/${dataTypeDefinitionId}`,
            method: "PATCH",
            body: dataTypeDefinitionUpdate,
        };
        return Api.createAjax(request)
                .pipe(
                        map((response) => {})
                ).toPromise();
    }

    delete(dataTypeDefinitionId: string): Promise<void> {
        const request: AjaxRequest = {
            url: `${DataTypeApiClient.ENDPOINT_URL}/${dataTypeDefinitionId}`,
            method: "DELETE",
        };
        return Api.createAjax(request)
            .pipe(
                map((response) => {})
            ).toPromise();
    }

    createConstraint(dataTypeDefinitionId: string, constraint: DataTypeConstraintCreateDto): Promise<string> {
        const request: AjaxRequest = {
            url: `${DataTypeApiClient.ENDPOINT_URL}/${dataTypeDefinitionId}/constraints`,
            method: "POST",
            body: constraint,
        };
        return Api.createAjax(request)
            .pipe(
                map((response) => response.response as string)
            ).toPromise();
    }

    deleteConstraint(dataTypeDefinitionId: string, constraintId: string): Promise<void> {
        const request: AjaxRequest = {
            url: `${DataTypeApiClient.ENDPOINT_URL}/${dataTypeDefinitionId}/constraints/${constraintId}`,
            method: "DELETE",
        };
        return Api.createAjax(request)
            .pipe(
                map((response) => {})
            ).toPromise();
    }

}
